export const enGB = 'en_GB'
export const roRO = 'ro_RO'



// WEBPACK FOOTER //
// ./src/modules/Locales.js